import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { RiderShell } from "@/components/Shells";
import BookWidget, { PENDING_RIDE_KEY } from "@/components/BookWidget";
import GuestLanding from "@/pages/GuestLanding";
import { FullScreenLoader } from "@/components/States";
import { api } from "@/lib/api";

export default function Home() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [resuming, setResuming] = useState(false);

  useEffect(() => {
    if (user?.role !== "customer") return;
    const raw = localStorage.getItem(PENDING_RIDE_KEY);
    if (!raw) return;
    localStorage.removeItem(PENDING_RIDE_KEY);
    setResuming(true);
    (async () => {
      try {
        const payload = JSON.parse(raw);
        const res = await api("/rides", { method: "POST", body: payload });
        navigate(`/ride/${res.ride.id}`);
      } catch {
        setResuming(false);
      }
    })();
  }, [user, navigate]);

  if (!user) return <GuestLanding />;
  if (resuming) return <FullScreenLoader />;
  return (
    <RiderShell fullBleed>
      <BookWidget />
    </RiderShell>
  );
}
